import classNames from 'classnames'

export interface ImageProps extends React.ComponentPropsWithoutRef<'img'> {}

export const Image = ({ className, ...props }: ImageProps) => {
  if (!props.src) {
    return (
      <div
        className={classNames('content-teaser__image--placeholder', className)}
      />
    )
  }

  return (
    <img
      className={classNames('content-teaser__image', className)}
      {...props}
    />
  )
}
